import React, { useEffect, useState } from "react";
import styles from "./campsiteShowcase.module.css";
import { ref, onValue } from "firebase/database";
import { dimaniwasRtdb } from "../../firebase/config";

const CampsiteShowcase = () => {
  const [tents, setTents] = useState([]);
  const [loading, setLoading] = useState(true);

  const whatsappNumber = "919365484564";

  useEffect(() => {
    const tentsRef = ref(dimaniwasRtdb, "tents");

    const unsubscribe = onValue(tentsRef, (snapshot) => {
      const data = snapshot.val();

      if (data) {
        const loadedTents = Object.values(data).map((tent) => ({
          name: tent.name,
          description: tent.description,
          price: `₹${tent.price} / day`,
          image: tent.image
        }));
        setTents(loadedTents.reverse());
      } else {
        // ✅ VERY IMPORTANT
        setTents([]);
      }

      // ✅ Stop loading in all cases
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const handleBookNow = (tent) => {
    const message = `
🏕️ *Campsite Booking Request*

📦 Tent Type: ${tent.name}
💰 Price: ${tent.price}

Please let me know the availability and further details.
    `;

    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
      message
    )}`;

    window.open(whatsappURL, "_blank");
  };

  return (
    <section className={styles.campsiteSection}>
      <div className={styles.campsiteHeader}>
        <h2 className={styles.campsiteTitle}>Our Tent Options</h2>
        <div className={styles.campsiteTitleUnderline}></div>
        <p className={styles.campsiteSubtitle}>
          Choose the perfect tent and enjoy a comfortable camping experience.
        </p>
      </div>

      {loading ? (
        <div className={styles.loaderWrapper}>
          <div className={styles.spinner}></div>
          <p>Loading tents...</p>
        </div>
      ) : tents.length === 0 ? (
        <p className={styles.statusText}>No tents available at the moment.</p>
      ) : (
        <div className={styles.campsiteGrid}>
          {tents.map((tent, index) => (
            <div key={index} className={styles.campsiteCard}>
              <div className={styles.campsiteImageWrapper}>
                <img
                  src={tent.image}
                  alt={tent.name}
                  className={styles.campsiteImage}
                />
                <div className={styles.campsitePrice}>{tent.price}</div>
              </div>

              <div className={styles.campsiteContent}>
                <h3 className={styles.campsitePackageTitle}>{tent.name}</h3>
                <p className={styles.campsiteDescription}>
                  {tent.description}
                </p>
                <button
                  className={styles.bookNowBtn}
                  onClick={() => handleBookNow(tent)}
                >
                  Book Now
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default CampsiteShowcase;
